import { SIDEBAR_VIEWS } from '../../../../lib/constants';
import Storage from '../../../../lib/storage';

export default (dispatch) => ({
  toggleCoords(coordsState) {
    dispatch({
      type: 'map/closePopup',
    });
    dispatch({
      type: 'app/setHideCoords',
      payload: !coordsState,
    });
  },

  showKeyboardShortcuts() {
    dispatch({
      type: 'app/gotoSidebarWithHistory',
      payload: SIDEBAR_VIEWS.KeyboardShortcuts,
    });
  },

  logout(redirect) {
    dispatch({
      type: 'user/logout',
      callback: () => {
        Storage.removeEncoded('currentUser');
        window.location.href = redirect;
      },
    });
  },
});
